import { type PropsWithChildren, type ReactNode } from 'react';
import {
  type RefinementListProps,
  useRefinementList } from
'react-instantsearch';
import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

import {
  Button,
  Checkbox,
  CheckboxGroup } from
'~/components/OddscheckerPlus/components/cxy';

import styles from './styles/BetTypeFilters.module.css';

export const CheckboxFilter = ({
  children,
  childrenPlacement = 'after',
  isDisabled = false,
  label,
  trackChange,
  transformFieldLabel,
  ...refinementProps








}: PropsWithChildren<RefinementListProps & {childrenPlacement?: 'before' | 'after';isDisabled?: boolean;label?: string;trackChange?: (value: string) => void;transformFieldLabel?: (item: RefinementListItem) => ReactNode;}>) => {
  const { canToggleShowMore, isShowingMore, items, refine, toggleShowMore } =
  useRefinementList({
    ...refinementProps
  });

  return (
    <>
			{label ?
      <CheckboxGroup aria-label={label} className={styles.select}>
					{childrenPlacement === 'before' && children}
					{items.map((item) => {
          return (
            <Checkbox
              checked={item.isRefined}
              disabled={isDisabled}
              key={item.value}
              onCheckedChange={() => {
                trackChange?.(item.value);
                refine(item.value);
              }}
              value={item.value}>

								{transformFieldLabel ? transformFieldLabel(item) : item.label}
							</Checkbox>);

        })}
					{childrenPlacement === 'after' && children}
				</CheckboxGroup> :

      <>
					{items.map((item) => {
          return (
            <Checkbox
              checked={item.isRefined}
              disabled={isDisabled}
              key={item.value}
              onCheckedChange={() => {
                trackChange?.(item.value);
                refine(item.value);
              }}
              value={item.value}>

								{transformFieldLabel ? transformFieldLabel(item) : item.label}
							</Checkbox>);

        })}
				</>
      }
			{canToggleShowMore &&
      <Button onClick={toggleShowMore} variant="ghost">
					{isShowingMore ? 'Show less' : 'Show more'}
				</Button>
      }
		</>);

};